import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import React from "react";
import { useDispatch } from "react-redux";
import { CustomFooter } from "./customFooter";
import { language } from "language/default";
import { closeDialog } from "store/messages-dialog";
export const InsDefaultDialogAction = () => {
    const dispatch = useDispatch();
    return React.createElement(CustomFooter, null,
        React.createElement(AuxButton, { label: language.en.common.ok, key: "main-ok-button", type: AuxButtonTypeEnum.PRIMARY, onClick: () => {
                dispatch(closeDialog());
            } }));
};
